import React from "react";
import { Modal } from "react-bootstrap";

const VIDEO_SRC =
  "https://iframe.dacast.com/vod/284d2e1d-0e05-44da-6e2a-be63739a10c7/373257b3-9e28-4b14-a3c5-f43e8860f91e";

const STEPS = [
  {
    title: "Enter billing details",
    text: "Add your payment information through our secure checkout.",
  },
  {
    title: "Confirm & start",
    text: "Get instant access to your dashboard right after payment.",
  },
];

export const PaymentTutorialModal = ({ show, handleClose }) => {
  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      centered
      className="ptModal"
    >
      <Modal.Body className="ptModal-body">
        <button className="ptModal-close" onClick={handleClose}>
          <i className="fa-solid fa-xmark" />
        </button>

        <div className="ptModal-grid">
          <div className="ptModal-info">
            <span className="ptModal-eyebrow">Quick walkthrough</span>
            <h3 className="ptModal-title">Payment Tutorial</h3>
            <p className="ptModal-sub">
              A short walkthrough to help you complete your subscription
              payment in a few simple steps.
            </p>

            <ul className="ptModal-steps">
              {STEPS.map((step, i) => (
                <li key={step.title}>
                  <span className="ptModal-step-num">{i + 1}</span>
                  <div>
                    <b>{step.title}</b>
                    <p>{step.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="ptModal-video-wrap">
            <div className="ptModal-video">
              <iframe
                src={VIDEO_SRC}
                title="Payment Tutorial"
                frameBorder="0"
                scrolling="no"
                allow="autoplay; encrypted-media; fullscreen"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
